import {PRODUCT_NO_IMG} from "../constants";
import Swiper, {Autoplay, EffectFade, FreeMode, Navigation, Pagination, Thumbs} from "swiper";

export function productImg(product) {
    if (product?.preview_image?.original_url) return product.preview_image.original_url
    else if (Array.isArray(product?.images) && !!product.images.length) return product.images[0].original_url
    return PRODUCT_NO_IMG
}

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src !== undefined)
                img.src = img.dataset.src; // подставляем настоящий src
            if (img.dataset.srcset !== undefined)
                img.srcset = img.dataset.srcset;
            img.classList.remove("lazy");
            observer.unobserve(img); // больше не наблюдаем за этим изображением
        }
    });
}, {
    rootMargin: '50px' // начинает загрузку за 50px до появления
});

export function addLoadListenerToLazyLoadObjects() {
    const lazyImages = document.querySelectorAll('.lazy');
    lazyImages.forEach(img => observer.observe(img));
}

function loadImageInSlide(slideEl) {
    const lazyImages = slideEl.querySelectorAll('.lazy-slider');
    lazyImages.forEach((img) => {
        if (img.dataset.src !== undefined) {
            img.src = img.dataset.src;
        }
        if (img.dataset.srcset !== undefined) {
            img.srcset = img.dataset.srcset;
        }
        img.classList.remove('lazy-slider');
    });
}

export function initSliders() {
    $('.popular-articles__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);

        // ищем стрелки и пагинацию только внутри текущего слайдера
        let $prev = $slider.parent().find('.popular-articles-swiper_prev');
        let $next = $slider.parent().find('.popular-articles-swiper_next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Pagination, Navigation],
            observer: true,
            observeParents: true,
            speed: 800,
            watchOverflow: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            breakpoints: {
                320: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                },
                700: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                    navigation: {
                        prevEl: $prev[0],
                        nextEl: $next[0],
                    },
                },
                1375: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                    navigation: {
                        prevEl: $prev[0],
                        nextEl: $next[0],
                    },
                },
            },
            on: {},
        });

        $slider.addClass('initialized');
    });

    $('.cards-main__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);

        let $prev = $slider.parent().find('.cards-main-button_prev');
        let $next = $slider.parent().find('.cards-main-button_next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Pagination, Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            effect: "fade",
            pagination: {
                el: $pagination[0],
                clickable: true
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0]
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
        });

        $slider.addClass('initialized');
    });

    $('.cards-article__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $container = $slider.closest('.cards-main');

        let $prev = $container.find('.cards-main-button_prev');
        let $next = $container.find('.cards-main-button_next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Pagination, Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            effect: "fade",
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                1220: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
            },
        });

        $slider.addClass('initialized');
    });

    $('.card__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);

        let $prev = $slider.find('.card-button_prev');
        let $next = $slider.find('.card-button_next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Pagination, EffectFade, Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            effect: "fade",
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0]
            },
            on: {
                slideChange(swiper) {
                    loadImageInSlide(swiper.slides[swiper.activeIndex]);
                }
            }
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.cards-swiper').not('.swiper-initialized').each(function () {
        let $slider = $(this);

        let $prev = $slider.find('.swiper-button-prev');
        let $next = $slider.find('.swiper-button-next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            slidesPerView: 4,
            spaceBetween: 8,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 3,
                },
                1170: {
                    slidesPerView: 4,
                },
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.main__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination, Autoplay],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            loop: true,
            touchRatio: 0,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.similar__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $prev = $slider.find('.swiper-button-prev');
        let $next = $slider.find('.swiper-button-next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            breakpoints: {
                320: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4,
                },
                1170: {
                    slidesPerView: 5,
                    spaceBetween: 26,
                },
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.simple-swiper').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $prev = $slider.find('.swiper-button-prev');
        let $next = $slider.find('.swiper-button-next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.popup-advertising__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $prev = $slider.find('.popup-swiper-button-prev');
        let $next = $slider.find('.popup-swiper-button-next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.company__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $prev = $slider.find('.swiper-button-prev');
        let $next = $slider.find('.swiper-button-next');
        let $pagination = $slider.find('.swiper-pagination');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination, FreeMode],
            observer: true,
            observeParents: true,
            slidesPerView: "auto",
            spaceBetween: 7,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            freeMode: true,
            pagination: {
                el: $pagination[0],
                clickable: true,
            },
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            breakpoints: {
                320: {
                    centeredSlides: true,
                },
                1171: {
                    centeredSlides: false,
                },
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.main-product__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $prev = $slider.find('.swiper-button-prev');
        let $next = $slider.find('.swiper-button-next');

        new Swiper($slider[0], {
            modules: [Navigation, Pagination, FreeMode, Thumbs],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            simulateTouch: true,
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            thumbs: {
                swiper: {
                    el: '.main-product__thumbs-slider',
                    slidesPerView: 5,
                    spaceBetween: 13,
                    touchRatio: 0,
                }
            },
            breakpoints: {
                320: {
                    centeredSlides: true,
                },
                1171: {
                    centeredSlides: false,
                },
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.main-blog-slider__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $pagination = $slider.find('.main-blog-slider__pagination');

        new Swiper($slider[0], {
            modules: [Pagination],
            observer: true,
            observeParents: true,
            speed: 800,
            watchOverflow: true,
            freeMode: true,
            pagination: {
                el: $pagination[0],
                clickable: true
            },
            breakpoints: {
                320: {
                    spaceBetween: 0,
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: "auto"
                }
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.popular-articles__slider').not('.swiper-initialized').each(function () {
        let $slider = $(this);
        let $pagination = $slider.find('.main-blog-slider__pagination');

        new Swiper($slider[0], {
            modules: [Pagination],
            observer: true,
            observeParents: true,
            speed: 800,
            watchOverflow: true,
            freeMode: true,
            pagination: {
                el: $pagination[0],
                clickable: true
            },
            breakpoints: {
                320: {
                    spaceBetween: 0,
                    slidesPerView: 1
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: "auto"
                }
            },
            on: {}
        });

        $slider.find('.card__slide-hidden').removeClass('card__slide-hidden');
        $slider.addClass('initialized');
    });

    $('.news-block__slider').not('.swiper-initialized').each(function () {
        new Swiper('.news-block__slider', {
            modules: [Pagination],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            watchOverflow: true,
            pagination: {
                el: ".news-block__pagination",
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            }
        });
    });
}
